import { CoinResponse } from "baaanggg";

type Props = {
    coin: CoinResponse,
    isSelected: boolean
}

export function CoinDropdownItem({ coin, isSelected }: Props) {
    return <span className="flex items-center space-x-3">
        <img src={coin.icon ?? "/src/img/coins/gold.svg"} className="h-6 w-6 rounded-full" loading="lazy"
            alt="avatar" />
        <span className={`${isSelected ? 'text-jacarta-500' : 'text-white'}`}>{coin.name}</span>
    </span>
}